import type { FC } from 'react';
import React from 'react';

import { Sheet } from '@sravni/react-design-system';
import type { SheetProps } from '@sravni/react-design-system/dist/types/components/Sheet';

import type { IClientMicrocreditListItem } from '@src/@types/clienttypes';
import { useIsPromoActive } from '@src/reducers/promo';
import { getPromoVariant } from 'entities/Promo/lib/getPromoVariant';
import { FullDealCalculatorBottomSheetActions } from 'features/FullDeal';
import { PromoDealCalculatorBottomSheetActions } from 'features/Promo/ui/PromoDealCalculatorBottomSheetActions/PromoDealCalculatorBottomSheetActions';

import { FullDealEntryPoint } from '../FullDealEntryPoint/FullDealEntryPoint';

import styles from './FullDealCalculatorBottomSheet.module.scss';

interface Props extends Pick<SheetProps, 'visible' | 'onClose'> {
  data: { heading?: string; offer: IClientMicrocreditListItem; position: number };
}

export const FullDealCalculatorBottomSheet: FC<Props> = ({ visible, onClose, data: { heading, offer, position } }) => {
  const isActivePromo = useIsPromoActive();
  return (
    // @ts-expect-error dragElastic не описан в типах библиотеки
    <Sheet visible={visible} onClose={onClose} dragElastic={false}>
      <Sheet.Content className={styles.sheetContent}>
        <FullDealEntryPoint
          shouldSetDefaultValuesInRedux={false}
          heading={heading}
          highlightOffer={false}
          renderActions={(props) =>
            getPromoVariant(
              isActivePromo,
              <PromoDealCalculatorBottomSheetActions offer={offer} {...props} />,
              <FullDealCalculatorBottomSheetActions offer={offer} position={position} {...props} />,
            )
          }
        />
      </Sheet.Content>
    </Sheet>
  );
};

FullDealCalculatorBottomSheet.displayName = 'FullDealCalculatorBottomSheet';
